import React from "react";
import { useState, useEffect } from "react";
import { useFirebaseUser } from "./firebase-auth";
import { Leaderboard } from "./leaderboard";
import { useCheckSteps } from "./check-steps";
// import UnopenedPackCounter from "./component/UnopenedPackCounter";
import "./style.css";
// import Countdown from "./Countdown";
import basePack from "./img/BasePack.png";
import megaPack from "./img/MegaPack.png";
import retroBasePack from "./img/BWBasePack.png"
import retroMegaPack from "./img/SephiaMegaPack.png"

export function MainBody() {
  const firebaseUser = useFirebaseUser();
  const checkSteps = useCheckSteps();
  const [alert, setAlert] = useState("");

  useEffect(() => {
    if (!checkSteps.didRegister) {
      setAlert("Please register for an account!");
    } else if (
      checkSteps.didRegister &&
      !checkSteps.didWallet &&
      !checkSteps.didGame
    ) {
      setAlert("Please add a wallet and connect a game to your account!");
    } else if (
      checkSteps.didRegister &&
      checkSteps.didWallet &&
      !checkSteps.didGame
    ) {
      setAlert("Please connect a game to your account !");
    } else if (
      checkSteps.didRegister &&
      !checkSteps.didWallet &&
      checkSteps.didGame
    ) {
      setAlert("Please add a wallet to your account!");
    } else {
      setAlert("ALL STEPS COMPLETE! YOU'RE FULLY REGISTERED!");
    }
  });

  return (
    <div>
      {/* Header */}
      <a name="home"></a>
      <section id="section-header">
        <div class="bg-overlay">
          <div class="header">
            <div class="game-logos">
              <img class="bfit" src="img/bfitlogo.png" />
              <img class="cc" src="img/cclogo.png" />
              <img class="tpb" src="img/tpblogo.png" />
            </div>
            <h1>

               NFT Collectibles
            </h1>
            <h2> from EAST SIDE GAMES and LDRLY</h2>
            <p>
              Be the first to have true ownership over digital assets from our
              hit games, starting with Cheech and Chong Bud Farm, The Trailer
              Park Boys: Greasy Money, and the Bud Farm: Idle Tycoon. Register,
              participate, qualify, and you could be awarded the first ever
              officially licenced NFTs from these iconic brands.
            </p>
            <a href="https://budfarm.wdny.io/">
              <button class="headerbtn">COLLECT NOW</button>
            </a>
            <a href="#about">
              <button class="headerbtn">WTF IS AN NFT</button>
            </a>
          </div>
        </div>
      </section>

      <section id="prizes">
        <img class="float-img niftystash" src="img/nifty.png" />
        <div id="float-img-btm">
          {/*  Card Packs */}
          <section class="card-packs">
            <img src={retroBasePack} alt="basePack" />
            {/* <p class="card-packTitle">Base Pack</p> */}
            <img src={retroMegaPack } alt="megaPack" />
            {/* <p class="card-packTitle">Mega Pack</p> */}
            {/* <img src="img/PromoPack.png" alt="promoPack" /> */}
            {/* <p class="card-packTitle">Promo Pack</p> */}
          </section>
          <div>
          <h1>Packs on Sale!</h1>
          <a href="https://budfarm.wdny.io/shop">
              <button class="headerbtn"  style={{ display: "block", marginLeft: "auto",
  marginRight: "auto",
  width: "40%"}}>BUY NOW</button>
            </a>
          </div>
          {/* <h1>NEW SALE COMING SOON!</h1> */}
          {/* <h3>Sale Ends June 7th at 4:20 PM PST!</h3> */}
          {/* <h3>The upcoming drop starts at 4:20 PM PST!</h3> */}
        </div>

        {/* <Countdown></Countdown> */}

        {/* <a href="https://budfarm.wdny.io/" >
          <button class="headerbtn niftybtn">BUY PACKS</button>
        </a> */}
      </section>

      {/* About */}
      <section id="about">
        <img
          class="float-img"
          src="img/twins.png"
          alt="Cheech and Chong Twins"
        />
        <div id="about2" class="whitecover">
          <h1>ABOUT</h1>
          <h3>How can I get my hands on these collectible NFT cards?</h3>
          <ul class="about-list">
            <span class="alert">{alert}</span>

            <li>
              <strong>
                1. Register with this website using the LOGIN button above, and
                create your account.
              </strong>
            </li>
            <li>
              <strong>
                2. Create a WAX Wallet by clicking on the WALLET button.
              </strong>
              {/* <br/>Download any or all the games from the app stores if you haven’t already. Open the game’s Settings Menu and touch the “420 Login” button. If you’re an existing player, each game will also prompt you to register for our current event. */}
            </li>
            <li>
              <strong>
                3. Link your account to any of our eligible mobile games by
                logging in from the games settings menu.{" "}
              </strong>
              <br />
              If you don’t already play Bud Farm: Idle Tycoon, Cheech and Chong
              Bud Farm, or Trailer Park Boys: Greasy Money, then download them
              from the App Store or Google Play Store to get started. Get going
              now because you will need to be at least level 6 to qualify for
              the special NFT awards!
            </li>
            <li>
              <strong>
                4. Participate in special global leaderboard events to earn special prizes.
              </strong>
            </li>
          </ul>

          <h3>Why do I want these NFT cards?</h3>
          <p>
            <a href="https://money.tmx.com/en/quote/LEAF">LEAF Mobile</a> is
            proud to announce our newest game ‘Bud Farm Nifty Stash’ - a
            collectible card game where you can buy, sell, trade, and combine
            cards. In this exciting game you will breed plants, run
            contraptions, and collect sets based on the Bud Farm Universe. The
            NFT cards that can be earned in our upcoming special event will be
            the first cards you can own for this new game, and will be among the
            most powerful and rare.
          </p>
        </div>
        <img class="about-image-btm" src="img/buds.png" alt="Buds" />
      </section>

      {/* Short Section */}

      <section id="shortsec">
        <div class="whitecover-long">
          <h3>
            How is it different from any other collectible card game out there?
          </h3>
          <p>
            Non-Fungible Tokens are unique tokens that live on the blockchain.
            Due to the fact that they are one-of-a-kind, and are on a
            decentralized platform, they can live forever and can be bought,
            sold, and traded on the blockchain. They are truly owned by you. We
            don’t control them, you do. More details about the game <a href="https://budfarm.wdny.io/faq ">here</a>.
          </p>
          <h3>When can I get these cards??</h3>
          <p>
          We’ll release new packs periodically which can be purchased, and opened, to obtain our newest NFTs. Register to get updates and details on new drops, as well as keep an eye on the market for people selling our previously released packs!
          </p>
        </div>
        <img class="shortsec-image-btm" src="img/gary.png" alt="Buds" />
      </section>

      {/* Leaderboard */}
      <section id="leadersection">
        <h1>LEADERBOARD</h1>
        <div id="leaderboard-table">
          <div id="Screenleft">
            <Leaderboard gameName={"bfweedrev"} />
          </div>

          <div id="Screenmiddle">
            <Leaderboard gameName={"tpbgame"} />
          </div>

          <div id="Screenright">
            <Leaderboard gameName={"bfcc"} />
          </div>
        </div>

        <div id="about2" class="leaderboard-textbg">
          <ul class="about-list">
            <p>
              <b>Leaderboard Rules & Rewards</b>
              <br />
              <br />
              <b>*</b> In order to qualify and compete in Leaderboards, you must
              complete the registration steps, above!
              <br />
              <br />
              <b>*</b> Leaderboards are not in real time. Leaderboard data
              updates periodically throughout the games' events.
              <br />
              <br />
              <b>*</b> All Players that are placed and earned a reward will be
              verified. Players found to be using any foul play, hacks,
              autoclickers or other unfair advantages will be removed from the
              contest and possibly banned from the game permanently.
              <br />
              <br />
              <b>*</b> Final Leaderboards will be posted after all events end.
              <br />
              <br />
              <b>*</b> Tokens won from leaderboards can be redeemed for an exclusive Jackpot Pack via our crafting page. Click <a href="https://budfarm.wdny.io/craft">HERE</a> to craft a pack using 1x Black Token, or 5x Red Tokens. Don’t have enough Red Tokens yet? Craft a Mystery Pack using 1x Red Token, or save up your Red Tokens until you have enough to craft a Jackpot Pack!
              <br /> 
              <br />
              <b>*</b> Prizes will be awarded within five business days after
              the contest ends to provide sufficient time for result
              verification.
            </p>
            <p>
              <br />
              <b>Bud Farm Idle: Tycoon</b>
              <br />
              {/* TBA */}
              Event runs from 2:00PM Pacific Wednesday January  26th.
              <br />
              <br />
              1st Place: 1x Black Token + Retro Pack.
              <br />
              2nd-5th Place: 1x Black Token + Retro Pack.
              <br />
              6th-25th Place: 1x Black Token.
              <br />
              26th-50th Place: 1x Red Token.
              <br />
              <br />
              <b>Trailer Park Boys: Greasy Money</b>
              <br />
              {/* TBA */}
              Event runs from 2:00PM Pacific Thursday January 27th.
              <br />
              <br />
              1st Place: 1x Black Token + Retro Pack.
              <br />
              2nd-5th Place: 1x Black Token + Retro Pack.
              <br />
              6th-25th Place: 1x Black Token.
              <br />
              26th-50th Place: 1x Red Token.
              <br />
              <br />
              <b>Cheech and Chong Bud Farm</b>
              <br />
              {/* TBA */}
              Event runs from 10:00AM Pacific Friday January 28th.
              <br />
              <br />
              1st Place: 1x Black Token + Retro Pack.
              <br />
              2nd-5th Place: 1x Black Token + Retro Pack.
              <br />
              6th-25th Place: 1x Black Token.
              <br />
              26th-50th Place: 1x Red Token.
            
            </p>
          </ul>
        </div>
      </section>

      {/* FAQ*/}
      <section id="faq">
        <div class="bg">
          <div class="whitecover">
            <h1>FAQ</h1>
            <h3>Man, I still don't get it</h3>
            <main>
              <details>
                <summary>How do I connect my game to the website?</summary>
                <div class="faq__content">
                  <p>
                    Go to the settings menu of your game and click the '420
                    Login' button. Follow the prompts to connect your game.
                  </p>
                </div>
              </details>

              <details>
                <summary>WTF is an NFT?</summary>
                <div class="faq__content">
                  <p>
                    A Non-Fungible Token. A digital thing (picture, sound,
                    video) you can truly own, because blockchain. They are
                    scarce, and they are tradable.
                    <br />
                    <br />
                    Other people have explained them better than we ever could
                    so{" "}
                    <a
                      href="https://www.theverge.com/22310188/nft-explainer-what-is-blockchain-crypto-art-faq"
                      target="_blank"
                    >
                      read more here
                    </a>{" "}
                    or{" "}
                    <a
                      href="https://twitter.com/i/status/1376032888764960769"
                      target="_blank"
                    >
                      watch this video.
                    </a>
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">
                  But how do I actually take ownership of it?
                </summary>
                <div class="faq__content">
                  <ul class="about-list">
                    <li>
                      <strong>
                        1. Register with NFTKit and create an account.
                      </strong>
                      <br />
                      You will need to choose a username and password, as well
                      as verify your email address. Link your mobile game
                      account to NFTKit.
                    </li>
                    <li>
                      <strong>
                        2. Link your mobile game account to NFTKit.
                      </strong>
                      <br />
                      Go to your game on your phone (download the game from the
                      App Store or Google Play store if you haven’t already).
                      Open up the settings menu, and link an eligible WAX Wallet
                      to your account.
                      <br />
                      You can download a WAX Wallet here, or log into your NFT
                      account and click the ‘CONNECT WAX WALLET’ button and
                      follow the prompts.
                    </li>
                  </ul>
                </div>
              </details>

              <details>
                <summary>But WHAT do I actually take ownership of it?</summary>
                <div class="faq__content">
                  <p>
                    Exact details will be released soon. Register now to be the
                    first to know!
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">
                  Tell me more about this new trading card game.
                </summary>
                <div class="faq__content">
                  <p>
                    It’s the newest game from the Bud Farm Universe.{" "}
                    <a href="https://budfarm.wdny.io/" target="_blank">
                      Bud Farm Nifty Stash
                    </a>{" "}
                    is a fun new way to explore and interact with the your
                    favourite characters, critters, and plants you have come to
                    know and love from our hit games Bud Farm: Idle Tycoon,
                    Cheech and Chong Bud Farm, Bud Farm: Grass Roots, Bud Farm
                    420, and the classic Pot Farm from 2011.
                    <br />
                    <br /> These games have been enjoyed by well over 30 Million
                    players and now, for the first time, players can truly and
                    permanently own these digital assets in an NFT format
                    through the WAX blockchain.
                  </p>
                </div>
              </details>

              <details>
                <summary>When is this game launching?</summary>
                <div class="faq__content">
                  <p>
                    The first assets for this new game will be launched on{" "}
                    <strong>APRIL 20th 2021.</strong>
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">Where can I get cards?</summary>
                <div class="faq__content">
                  <p>
                  Cards will be available for sale as we release new series to buy. Additionally, special exclusive cards are available as rewards for our global leaderboards in our mobile games -- Bud Farm: Idle Tycoon, Cheech and Chong Bud Farm, and Trailer Park Boys: Greasy Money. Be sure to download our games, follow us on social media, and register with this website to be the first to know about new pack drops and upcoming events.
                  </p>
                </div>
              </details>

              <details>
                <summary>What can I do with these cards?</summary>
                <div class="faq__content">
                  <p>
                    Buy, sell, trade, and combine cards to complete sets, unlock
                    special abilities, and breed new plants. Be sure to get as
                    many cards as you can from our beta drop as these cards will
                    be the most valuable and rare!
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">Can I get cards for free?</summary>
                <div class="faq__content">
                  <p>
                    Yes. You can earn cards as rewards in our games as well as
                    receive special awards just by registering, linking your
                    mobile game, and linking your WAX Wallet.
                  </p>
                </div>
              </details>

              <details>
                <summary>How many cards can I buy?</summary>
                <div class="faq__content">
                  <p>
                    Packs are limited in both the amount, frequency, and
                    conditions you need to buy them. Every drop is different!
                    You can buy, sell, and trade as many as you want in the
                    marketplace.
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">
                  How much can I sell my cards for?
                </summary>
                <div class="faq__content">
                  <p>
                    As much as you want, or more clearly, as much as someone is
                    willing to pay. You can list your cards for sale for any
                    amount you want in the marketplaces. There is a 10% fee on
                    any sale which is shared among the 3rd party marketplace,
                    the WAX platform, and us as the game developer.
                  </p>
                </div>
              </details>

              <details>
                <summary>
                  When you say that I ‘own’ the card, what does that mean?
                </summary>
                <div class="faq__content">
                  <p>
                    An NFT is a unique token and you can do with that token what
                    you please. The intellectual property is retained by LEAF
                    Mobile. You can buy, sell, and trade the token, however, the
                    artwork and characters still belong to the LEAF Mobile. You
                    can’t make merch and sell them, but you can display the art
                    anywhere you want. 3rd parties can sort and display, but
                    they can’t do anything with the art that would be
                    disparaging or detrimental to the IP.
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">
                  How often will new cards be released?
                </summary>
                <div class="faq__content">
                  <p>
                    New cards will be released most weeks. Sometimes that will
                    be in card pack releases. Sometimes they can only be earned
                    in our mobile games. Sometimes only people who already own
                    certain combinations of cards will have access. Every week
                    is different so keep your eyes peeled!
                  </p>
                </div>
              </details>

              <details>
                <summary>What are the different Rarities?</summary>
                <div class="faq__content">
                  <p>
                    <strong>Common.</strong> These are the most plentiful cards
                    and will be released repeatedly, but sometimes with
                    different art and always with higher and higher series
                    numbers. These cards are usually base strains of weed.
                    <br />
                    <strong>Uncommon.</strong> These are much less common but
                    still plentiful, and in unlimited runs. Uncommon cards are
                    unusual strains and breeds of weed as well as other things
                    like contraptions, products, and decorations for your farm
                    (coming soon).
                    <br />
                    <strong>Rare.</strong> These are very difficult to attain,
                    and even though they can occasionally be found in card
                    packs, they are often only obtainable through crafting
                    recipes.
                    <br />
                    <strong>Epic.</strong> These cards are exceptional and only
                    the elite Bud Farm players will have them. They are almost
                    never found in packs, and take time and patience to craft.
                    <br />
                    <strong>Legendary.</strong> These cards can generally only
                    be earned over long periods of time, or become available
                    during special events in our mobile game.
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">
                  What are Crafting recipes and how can I combine my cards to
                  get other cards?
                </summary>
                <div class="faq__content">
                  <p>
                    Every week we will release limited time CRAFTING RECIPES,
                    which allow you to burn a certain group of cards, and
                    receive a different card in return. Sometimes it is a
                    specific card, sometimes it is one of a set of cards. As an
                    example, we may ask you to burn 5 common cards and give you
                    an uncommon card that you can’t get anywhere else. Recipes
                    change constantly and are only available for a limited time,
                    or sometimes only can be made a limited amount of times, so
                    be quick before the cards are all gone!
                  </p>
                </div>
              </details>

              <details>
                <summary>What does a limited edition mean?</summary>
                <div class="faq__content">
                  <p>
                    This means that there are only a specific number of cards
                    made for that card. For example a card may be a limited run
                    of only 500 instances. Once they are all given out, that
                    particular card will never be minted again. As cards from
                    that limited run are burned in recipes, that number of cards
                    that exist are fewer and fewer. This makes them very scarce,
                    so you may want to keep them in your stash and be one of
                    only very few that has that card.
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">
                  What is a serial number and why does it matter?
                </summary>
                <div class="faq__content">
                  <p>
                    A series number is an indication of how early a card was
                    minted, eg: card 24 was minted before card 25. If we only
                    made 500 of a particular card, then the very first one
                    minted with serial number #001 was the first one ever made.
                    I’d like to own that one. Also I want to own card #420
                    because that is just straight up OG.
                  </p>
                </div>
              </details>

              <details>
                <summary>
                  My card has a weird background and is moving around!?!??
                </summary>
                <div class="faq__content">
                  <p>
                    You may have found a very special card! As well as rarities,
                    some cards have special properties and attributes like
                    animations, foil backgrounds, and hidden easter eggs.
                  </p>
                </div>
              </details>

              <details>
                <summary class="faqcolor">
                  This looks pretty simple right now, where is the ‘game’?
                </summary>
                <div class="faq__content">
                  <p>
                    MUCH MUCH MORE is coming soon as we aim to grow{" "}
                    <a href="https://budfarm.wdny.io/" target="_blank">
                      Bud Farm Nifty Stash
                    </a>{" "}
                    into the biggest collector game in the world. Build your
                    stash now so you can be the king or queen of Bud Farm when
                    it hits full worldwide launch soon.
                  </p>
                </div>
              </details>
            </main>
          </div>
          <div id="float-img-btm">
            <img src="img/burger.png" alt="Fat Cow" />
          </div>
        </div>
      </section>

      {/* Footer*/}
      <section id="footer" class="smoothscroll">
        <div class="footerbg">
          <div id="footertext">
            <h1>CUSTOMER SUPPORT</h1>
          </div>
          {/* <div id="social-icons">
								<a href="#"><img src="img/tw.png" alt="Twitter"/></a>
								<a href="#"><img src="img/ig.png" alt="Instagram"/></a>
								<a href="#"><img src="img/fb.png" alt="Facebook"/></a>
							</div> */}

          <div class="footerlinks">
            <button class="headerbtn">
              <a
                href="mailto:support@wesupportgames.zendesk.com"
                target="_blank"
              >
                General Support
              </a>
            </button>
            <button class="headerbtn">
              <a href="mailto:support@tpbgame.zendesk.com" target="_blank">
                Trailer Park Boys: Greasy Money
              </a>
            </button>
            <button class="headerbtn">
              <a href="mailto:support@budfarmidle.zendesk.com" target="_blank">
                Bud Farm: Idle Tycoon
              </a>
            </button>
            <button class="headerbtn">
              <a
                href="mailto:support@cheechandchongbudfarm.zendesk.com"
                target="_blank"
              >
                Cheech and Chong Budfarm
              </a>
            </button>
          </div>
          {/*		   		<ul class="footerlinks">
					   				<li><a href="mailto:support@tpbgame.zendesk.com">Trailer Park Boys: Greasy Money</a></li>
									<li><a href="mailto:support@alwayssunnygame.zendesk.com">It’s Always Sunny: The Gang Goes Mobile</a></li>
									<li><a href="mailto:dragonup-support@nightgardenstudio.com">Cheech and Chong Budfarm</a></li>
				            </ul> */}

          <div id="esglogo">
            <a href="http://www.eastsidegamestudio.com">
              <img src="img/esg-sig.png" alt="East Side Games" />
            </a>
            <a href="http://www.ldrlygames.io">
              <img src="img/ldrly.png" alt="East Side Games" />
            </a>
            <p>
              Proudly built by <strong>East Side Games</strong>
            </p>
          </div>
          <div class="fineprint">
            <ul>
              <li>
                <a
                  href="http://www.eastsidegames.com/terms-of-service/"
                  target="_blank"
                >
                  <p>TERMS OF SERVICE </p>
                </a>
              </li>
              <li>
                <a
                  href="http://www.eastsidegames.com/privacy-policy/"
                  target="_blank"
                >
                  <p>PRIVACY POLICY </p>
                </a>
              </li>
              <li>
                <a href="http://www.eastsidegames.com/contact/" target="_blank">
                  <p>BUSINESS INQUIRIES</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
